<template>
  <div>
    <form
      v-if="projectData"
      class="form--custom"
      novalidate
      @submit.prevent="handleSubmit"
    >
      <div :style="`height: ${contentHeight};`" class="px-3 pt-4 overflow--y">
        <label>{{ `${$t(`${namespace}.projectName`)}` }}</label>
        <v-text-field
          v-model="projectData.name"
          :name="errors.collect($t(`${namespace}.fieldName`))"
          :placeholder="`${$t(`${namespace}.fieldNamePlaceholder`)} *`"
          color="primary"
          return-masked-value
          v-validate="{ required: true }"
          :error-messages="errors.collect($t(`${namespace}.fieldName`))"
          :data-vv-name="$t(`${namespace}.fieldName`)"
          required
          outlined
        />

        <label>{{ $t('Common.company') }}</label>
        <AutoComplete
          kind="company"
          :data="projectData.company"
          :placeholder="$t(`Views.CostCenterPage.fieldCompanyPlaceholder`)"
          :isValid="isCompanyValid"
          required
          @input="updateCompany"
        />

        <label>{{ `${$t(`${namespace}.attachCostCenter`)}` }}</label>
        <AutoComplete
          kind="costCenter"
          :data="projectData.costCenters"
          :companyId="projectData.companyId || null"
          :placeholder="$t('Components.EmployeeForm.costCenter')"
          multiple
          @input="updateConstCenter"
        />
      </div>

      <v-divider />

      <div class="pt-4 pb-3">
        <div class="text--center">
          <v-btn
            type="submit"
            color="primary"
            :disabled="isLoading || isDisabled"
            :loading="isLoading"
            rounded
            depressed
          >
            {{ $t('Common.saveChanges') }}
          </v-btn>
        </div>

        <div class="text--center mt-3">
          <a
            v-if="!isLoading"
            href="#"
            class="accent--text"
            @click.prevent="close"
          >
            {{ $t('Common.cancel') }}
          </a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isValidArray, isValidObject, calcContentHeight, catchError } from 'corp-front-vue-commons/src/utils/functions'
import AutoComplete from 'components/AutoComplete'

export default {
  name: 'Edit',
  props: {
    data: {
      type: Object
    }
  },
  components: {
    AutoComplete
  },
  computed: {
    ...mapState({
      company: state => state.company.selectedCompany
    })
  },
  data () {
    return {
      namespace: 'Components.ProjectForm',
      isLoading: false,
      isDisabled: false,
      projectData: null,
      contentHeight: 'none',

      // extra validation
      isValidCostCenter: true,
      isCompanyValid: true
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error'
    }),

    isValidArray (val) {
      return isValidArray(val)
    },

    isValidObject (val) {
      return isValidObject(val)
    },

    calcContentHeight () {
      this.contentHeight = `${calcContentHeight() - 125}px`
    },

    close () {
      this.$emit('close')
    },

    updateCompany (val) {
      if (!this.isValidObject(val)) {
        this.projectData.companyId = null
        this.isCompanyValid = false
        return
      }

      this.projectData.companyId = val.id
      this.isCompanyValid = true
    },

    updateConstCenter (val) {
      if (!this.isValidArray(val)) {
        this.projectData.costCenters = []
        return
      }

      this.projectData.costCenters = val
    },

    async handleSubmit () {
      this.isLoading = true

      if (!this.projectData.companyId) {
        this.isCompanyValid = false
      }

      try {
        const isValid = await this.$validator.validateAll()

        if (isValid && this.projectData.companyId) {
          this.projectData.costCenters = this.projectData.costCenters.map(item => item.id)
          await this.$apiService.updateProject(this.projectData)
          this.$emit('toggleAction', 'preview')
          this.successAlert(this.$t(`${this.namespace}.editSuccess`))
        }
      } catch (error) {
        catchError(error)
        this.errorAlert(this.$t(`${this.namespace}.editError`))
      }

      this.isLoading = false
    }
  },
  watch: {
    company (val) {
      if (!val) {
        this.isCompanyValid = false
        return
      }

      this.isCompanyValid = true
    },

    'projectDatacostCenters' (val) {
      if (!val) {
        this.isValidCostCenter = false
        return
      }

      this.isValidCostCenter = true
    }
  },
  created () {
    this.projectData = {
      ...this.data
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>
